import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const useCardRelatedAdClick = ({
  ad,
  extendedTrackingData = {},
  listType = '',
  onClickCard = () => {},
  pageNameOrigin = '',
  pageType = '',
  position = 0
}) => {
  const {push} = useRouter()
  const {domain} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const mapPriceIndicator = indicator => {
    const {PRICE_INDICATOR_LABEL_RANK} = domain.get('config').get('priceIndicator')

    return PRICE_INDICATOR_LABEL_RANK[indicator] || ''
  }

  return ({shouldNavigate = true} = {}) => {
    const {TRACKING_EVENT_NAMES} = domain.get('config').get('tracking')

    track({
      event: TRACKING_EVENT_NAMES.AD_LIST_CLICKED,
      data: {
        ad_id: ad.id,
        page_type: pageType,
        page_name_origin: pageNameOrigin,
        has_pricedrop: Boolean(ad.priceDrop),
        products: [
          {
            id: ad.id,
            category: 'ads',
            price: ad.price,
            quantity: 0,
            list_type: listType,
            list_position: position + 1,
            price_indicator: mapPriceIndicator(ad.priceRankIndicator),
            package: ad.pack?.type
          }
        ]
      }
    })

    onClickCard()

    shouldNavigate &&
      push({
        pathname: ad.url,
        state: {
          filters: extendedTrackingData.filters,
          product: extendedTrackingData.products?.find(product => product.id === ad.id),
          provinces: extendedTrackingData.provinces,
          pageType: pageType || '',
          pageNameOrigin: pageNameOrigin || '',
          listType: listType || ''
        }
      })
  }
}

export default useCardRelatedAdClick
